module.exports = __webpack_public_path__ + "static/media/sensor-alert.86a2191f.svg";